module.exports = __webpack_public_path__ + "static/media/blueDot.a3388c6e.svg";